import React, { useEffect, useState, useRef } from 'react';
const tools = [{
  name: 'Claude',
  description: 'Reasoning & writing',
  color: 'var(--orange)',
  logo: 'https://claude.ai/favicon.ico'
}, {
  name: 'Cursor',
  description: 'AI code editor',
  color: 'var(--text)',
  logo: 'https://www.cursor.com/favicon.ico'
}, {
  name: 'Lovable',
  description: 'Full-stack prototyping',
  color: 'var(--pink)',
  logo: 'https://lovable.dev/favicon.ico'
}, {
  name: 'Magic Patterns',
  description: 'UI generation',
  color: 'var(--green)',
  logo: 'https://www.magicpatterns.com/favicon.ico'
}];
export function AITools() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return <section className="py-24 px-6 border-t" style={{
    backgroundColor: 'var(--bg)',
    borderColor: 'var(--border)'
  }} data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div ref={ref} className="transition-all duration-700 ease-out" style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(16px)'
      }} data-id="element-3">
          <div className="flex flex-col gap-4 mb-16" data-id="element-4">
            <h2 style={{
            color: 'var(--text)',
            fontFamily: 'var(--font-heading)',
            fontSize: 'var(--text-heading)',
            fontWeight: 'normal'
          }} data-id="element-5">
              Our favorite AI tools
            </h2>
            <p className="leading-relaxed" style={{
            color: 'var(--text-muted)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-body)',
            fontWeight: '400'
          }} data-id="element-6">
              We use the latest AI tools alongside our experience, taste, and
              judgment to deliver high-quality designs, quickly.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-7">
          {tools.map((tool, i) => <ToolCard key={tool.name} tool={tool} index={i} parentVisible={visible} data-id="element-8" />)}
        </div>
      </div>
    </section>;
}
function ToolCard({
  tool,
  index,
  parentVisible
}: {
  tool: (typeof tools)[0];
  index: number;
  parentVisible: boolean;
}) {
  return <div className="p-6 rounded-2xl border transition-all duration-700 ease-out" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'white',
    opacity: parentVisible ? 1 : 0,
    transform: parentVisible ? 'translateY(0)' : 'translateY(20px)',
    transitionDelay: `${index * 80 + 200}ms`
  }} data-id="element-9">
      <img src={tool.logo} alt={`${tool.name} logo`} className="mb-4" style={{
      width: '36px',
      height: '36px',
      objectFit: 'contain',
      borderRadius: '8px'
    }} data-id="element-10" />
      <p className="mb-1" style={{
      color: tool.color,
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-title)',
      fontWeight: '600'
    }} data-id="element-11">
        {tool.name}
      </p>
      <p style={{
      color: 'var(--text-muted)',
      fontFamily: 'var(--font-sans)',
      fontSize: 'var(--text-body)',
      fontWeight: '400'
    }} data-id="element-12">
        {tool.description}
      </p>
    </div>;
}